<template lang="pug">
  select.custom-select(v-model="value" @change="emitAction()")
    option(:value="''")
    option(:value="3") Extend 3 months
    option(:value="6") Extend 6 months
    option(:value="12") Extend 12 months
    option(:value="'delete'" v-if="includeDelete") Delete
    option(:value="'edit'" v-if="includeEdit") Edit
</template>

<script>
export default {
  name: 'WatchAction',
  props: {
    watchId: {
      type: [String, Number],
      default: 'bulk',
    },
    includeDelete: {
      type: Boolean,
      default: false,
    },
    includeEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: '',
    }
  },
  methods: {
    emitAction() {
      this.$emit('input', {
        action: this.value,
        watchId: this.watchId,
        confirmed: false,
      })
      this.value = ''
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
